import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'

import SignupComponent from '../../../components/authentication/signup';
import { useAppDispatch } from '../../../hooks/reduxHooks';
import { registerApi } from '../../../services/auth.service';


interface SignupContainerInterface {

}

const SignupContainer: React.FC<SignupContainerInterface> = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  // const { r } = Object.fromEntries(new URLSearchParams(location.search));
  const [registerErrors, setRegisterErrors] = useState();
  const navigate = useNavigate();


  const handleSignup = (val?: any) => {
    let subObj = {
      ...val,
      // referral_code: r
    }

    setSubmitting(true)
    dispatch(registerApi({
      data: subObj,
      successCallback: () => {
        navigate("/skincaresteps");
      },
      failureCallback: (response?: any) => {
        setRegisterErrors(response?.errors)
      },
      finalCallback: () => {
        setSubmitting(false)
      }
    }))
  }

  const handleBackButton = () => {
    navigate(-1)
  }

  return (
    <SignupComponent
      handleSignup={handleSignup}
      submitting={submitting}
      registerErrors={registerErrors}
      handleBackButton={handleBackButton}
    />
  )
}

export default SignupContainer;
